import React from "react";

export const COLORS: { [id: string]: string } = {
    FF: "#D22D49",
    SL: "#EEE716",
    CU: "#33DAF1",
    SI: "#FE9D00",
    CH: "#1DBE3A",
    ST: "#DDB33A",
    KN: "#6369D7",
    FC: "#94412E",
    FS: "#62BDBD",
    KC: "#7B36D7",
    SV: "#93AFD4",
    DB: "#1e43beff"
};

export const COLORS_FULL: { [id: string]: string } = {
    "4-Seam": "#D22D49",
    "Slider": "#EEE716",
    "Curve": "#33DAF1",
    "Sinker": "#FE9D00",
    "Change": "#1DBE3A",
    "Sweeper": "#DDB33A",
    "Knuckle": "#6369D7",
    "Cutter": "#94412E",
    "Splitter": "#62BDBD",
    "K-Curve": "#7B36D7",
    "Slurve": "#93AFD4",
    "Death Ball": "#1e43beff"
};

export const KEY: { [id: string]: string } = {
    FF: "4-Seam",
    SL: "Slider",
    CU: "Curve",
    SI: "Sinker",
    CH: "Change",
    ST: "Sweeper",
    KN: "Knuckle",
    FC: "Cutter",
    FS: "Splitter",
    KC: "K-Curve",
    SV: "Slurve",
    DB: "Death Ball"
};

export const EVENT_COLORS: { [id: string]: string } = {
    field_out: "#BDBDBD",
    single: "#008000",
    double: "#0000FF",
    home_run: "#f7eb11",
    grounded_into_double_play: "#BDBDBD",
    force_out: "#BDBDBD",
    field_error: "#BDBDBD",
    sac_fly: "#BDBDBD",
    sac_bunt: "#BDBDBD",
    triple: "#f42f11",
    double_play: "#BDBDBD",
    fielders_choice_out: "#BDBDBD",
    fielders_choice: "#BDBDBD",
};

export const TRAJ_COLORS: { [id: string]: string } = {
    ground_ball: "#BDBDBD",
    line_drive: "#008000",
    fly_ball: "#0000FF",
};

export const legendColors: any[] = [
    { key: "4-Seam", color: "#D22D49" },
    { key: "Slider", color: "#EEE716" },
    { key: "Curve", color: "#33DAF1" },
    { key: "Sinker", color: "#FE9D00" },
    { key: "Change", color: "#1DBE3A" },
    { key: "Sweeper", color: "#DDB33A" },
    { key: "Knuckle", color: "#6369D7" },
    { key: "Cutter", color: "#94412E" },
    { key: "Splitter", color: "#62BDBD" },
    { key: "K-Curve", color: "#7B36D7"},
    { key: "Slurve", color: "#93AFD4"},
    { key: "Death Ball", color: "#1e43beff"}
];

export const legendEventColors: any[] = [
    { key: "Single", color: "#008000" },
    { key: "Double", color: "#0000FF" },
    { key: "Triple", color: "#f42f11" },
    { key: "Home Run", color: "#f7eb11" },
];

export const legendTrajColors: any[] = [
    { key: "Ground Ball", color: "#BDBDBD" },
    { key: "Line Drive", color: "#008000" },
    { key: "Fly Ball", color: "#0000FF" },
];

// Custom Legend Component
export const CustomLegend: React.FC<{ colors: any[] }> = ({ colors }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "15px",
            marginBottom: "20px",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "80%"
        }}
    >
        {colors.map((legend) => (
            <div key={legend.key} style={{ display: "flex", alignItems: "center" }}>
                <div
                    style={{
                        width: "15px",
                        height: "15px",
                        backgroundColor: legend.color,
                        marginRight: "8px",
                    }}
                />
                <span style={{ fontSize: "14px" }}>{legend.key}</span>
            </div>
        ))}
    </div>
);

export const labelFormatter = (label: number, payload: any) => {
    const dataPoint = payload.find((p: any) => p.payload.x === label);
    return dataPoint ? `Pitch Type: ${dataPoint.payload.pitch_type}` : label;
};
